import {type MediaCardType} from '@wandb/weave/common/types/media';

import {useIsInLoadedReportContext} from '../../../pages/ReportPage/LoadedReportContext';
import {useRampFlagMediaCompareSyncZoomUser} from '../../../util/rampFeatureFlags/rampFeatureFlags';
import {type FanOutVariable, type LayoutMode} from '../common';

type Props = {
  config: {
    mode?: LayoutMode;
    compareSettings?: {fanOutVariable?: FanOutVariable};
  };
  mediaType: MediaCardType | null;
};

/** Derives tile eligibility from the current layout. */
export function useIsCompareSynced({config, mediaType}: Props) {
  const gateOn = useRampFlagMediaCompareSyncZoomUser() === true;
  const inReport = useIsInLoadedReportContext();
  return (
    gateOn &&
    !inReport &&
    config.mode === 'compare' &&
    config.compareSettings?.fanOutVariable == null &&
    mediaType === 'image'
  );
}
